import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import classNames from 'classnames';
import Field from '../Field.js';
import FieldGroup, { FieldChoiceGroup } from '../FieldGroup.js';
import styles from './ApplicationForm.module.scss';
import { useEffect } from 'react';
import { useApplicationEssayMinChars } from '@/hooks/useApplicationEssayMinChars';
function Goals() {
  const $ = _c(16);
  const formik = useFormikContext();
  const minChars = useApplicationEssayMinChars();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  const essayError = formik.errors.reasonForCollege;
  const attempted = formik.submitCount > 0 || !!formik.status?.nextBlocked;
  const showEssayError = !!essayError && (essayError.startsWith("Min ") && attempted || !essayError.startsWith("Min "));
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FieldChoiceGroup legend={<><span className={styles["legend-line"]}>What is your motivation for attending college at Campus?</span><span className={classNames(styles["legend-line"], styles["legend-line--hint"])}>Select all that apply.</span></>}><Field type="checkbox" name="transferToCollege" label="Transfer to a 4-year college" /><Field type="checkbox" name="startCareer" label="Start my career" /><Field type="checkbox" name="changeCareer" label="Change my career" /><Field type="checkbox" name="changeLife" label="Change my life circumstances" /><Field type="checkbox" name="meetPeople" label="Meet new people" /><Field type="checkbox" name="startBusiness" label="Start my own business" /><Field type="checkbox" name="other" label="Other" /></FieldChoiceGroup>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== formik.values.other) {
    t2 = !!formik.values.other && <FieldGroup><Field type="text" name="otherMotivation" label="Other motivation" placeholder="Describe other motivation" /></FieldGroup>;
    $[2] = formik.values.other;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = showEssayError ? essayError : null;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Field type="textarea" name="reasonForCollege" label="Reason for college" placeholder="Please share in three to four sentences." />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <FieldGroup label="Campus is here for the dreamers, the doers, the determined. In 3-4 sentences, share why you want to go to college and how it fits into your future." error={t3}>{t4}</FieldGroup>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = formik.values.reasonForCollege ? formik.values.reasonForCollege.length : 0;
  let t7;
  if ($[7] !== minChars) {
    t7 = <span className={styles["char-count__limits"]}>(min {minChars}, max 800)</span>;
    $[7] = minChars;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <p className={styles["char-count"]}>{t6}{" "}characters{" "}{t7}</p>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t5 || $[14] !== t8) {
    t9 = <>{t1}{t2}{t5}{t8}</>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
function _temp() {
  window.scrollTo({
    top: 0,
    behavior: "auto"
  });
}
export default Goals;